<template>
  <div class="embodySuccess">
    <van-sticky>
      <div
        class="embodySuccessNav"
        :style="{ 'padding-top': (isiOSX ? 44 : 24) + 'px' }"
      >
        <img
          class="navLeft"
          @click="goBack()"
          src="./../../../assets/decoration/back.png"
        />
        <span class="navTitle">提交结果</span>
      </div>
    </van-sticky>
    <div class="content">
      <div class="card succeed">
        <div>
          <img src="./../../../assets/decoration/complete.png" alt="" />
          <h2>提交成功</h2>
          <p>提现申请将在1-7个工作日内进行审核，请您耐心等待</p>
        </div>
        <p>
          <span>提现</span>
          <span>{{ money }}</span>
        </p>
      </div>
      <div class="succeedBtn">
        <span @click="goBack()">返回提现页</span>
        <span @click="toEmbodyDetails()">提现详情</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isiOSX: false,
      money: null,
      id: null,
      type: 1,
    };
  },
  created() {
    this.isiOSX = this.isIphoneX();
    this.$api.setToken(JSON.parse(sessionStorage.getItem("token")));
    if (this.$route.query.money) {
      this.money = this.$route.query.money;
    }
    if (this.$route.query.id) {
      this.id = this.$route.query.id;
    }
    if (this.$route.query.type) {
      this.type = this.$route.query.type;
    }
  },
  mounted() {},
  methods: {
    goBack() {
      this.$router.go(-2);
    },
    toEmbodyDetails() {
      this.$router.push({
        path: "/decoration/embody/embodyDetails",
        query: {
          id: this.id,
          type: this.type,
        },
      });
    },
  },
};
</script>
<style lang="less">
.embodySuccess {
  height: 100%;
  background: #f5f6ff;
  .embodySuccessNav {
    background: #ffffff;
    height: 44px;
    position: relative;
    .navLeft {
      width: 24px;
      height: 24px;
      position: absolute;
      left: 16px;
      bottom: 10px;
    }
    .navTitle {
      position: absolute;
      left: 50%;
      bottom: 10px;
      transform: translateX(-50%);
      font-size: 17px;
      font-weight: 700;
      color: #404247;
    }
  }
  .content {
    margin: 0 16px;
    .card {
      margin-top: 12px;
      background: #ffffff;
      border-radius: 12px;
      padding: 0 24px;
      div {
        display: flex;
        flex-direction: column;
        align-items: center;
        img {
          width: 72px;
          height: 72px;
          margin-top: 48px;
        }
        h2 {
          font-size: 20px;
          color: #333333;
          line-height: 28px;
          margin: 32px 0 0;
        }
        p {
          font-size: 14px;
          color: #999999;
          line-height: 20px;
          margin: 16px 27px 0;
          text-align: center;
        }
      }
    }
    .succeed {
      padding-bottom: 32px;
      div {
        padding-bottom: 39px;
        border-bottom: 1px solid #f0f1ff;
        margin-bottom: 12px;
      }
      > p {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-top: 20px;
        font-size: 15px;
        color: #333333;
        line-height: 21px;
        span:first-child {
          color: #999999;
        }
      }
    }
    .succeedBtn {
      margin-top: 24px;
      display: flex;
      justify-content: space-between;
      span {
        height: 40px;
        line-height: 40px;
        text-align: center;
        font-size: 15px;
        border-radius: 25px;
        width: 47%;
      }
      span:first-child {
        border: 1px solid #bdbfce;
        color: #666666;
      }
      span:last-child {
        border: 1px solid #5853e9;
        color: #5853e9;
      }
    }
  }
}
</style>